import { useNavigate } from "react-router-dom";

import { History } from "./navigation";

const NavigationBridge = () => {
    History.navigate = useNavigate();

    return null;
};

export default NavigationBridge;
